import { render, staticRenderFns } from "./Cobrar.vue?vue&type=template&id=64b1a9cf"
import script from "./Cobrar.vue?vue&type=script&lang=js"
export * from "./Cobrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports